import $ from 'jquery';
import debounce from 'lodash/debounce';
import bind from 'lodash/bind';
import get from 'lodash/get';
import { i18n } from '../../translation';
import { trackMemberSignup } from '../../scripts/tag-manager';
import './MemberSignupForm.scss';
import template from './MemberSignupForm.vhtml';

export default {
	name: 'MemberSignupForm',
	template: template,
	props: {
		industries: {
			type: Array,
			default: () => [],
		},
		consultants: {
			type: Array,
			default: () => [],
		},
		subscriptions: {
			type: Array,
			default: () => [],
		},
		privacyLink: {
			default: '',
		},
		termsLink: {
			default: '',
		},
		newsletterPopupFields: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		isSubmitting: false,
		submitStatus: '',
		result: {},
		signupData: null,
		honey: '',
		hasTimeout: false,
		isFetching: false,
		responseMessage: '',
		messageClass: '',
		showMessage: false,
		newsletterChecked: false,
		popup: '',
		newsletterPopup: [],
		acceptNewsletterTerms: false,
		selectedConsultant: '',
		selectedIndustry: '',
		selectedSubscription: false,
		options: [
			{
				label: i18n.tc('business'),
				title: 'business_esbjerg',
			},
			{
				label: i18n.tc('entrepreneurship'),
				title: 'entrepreneur',
			},
			{
				label: i18n.tc('invest_in_esbjerg'),
				title: 'invest_in_esbjerg',
			},
		],
	}),
	computed: {
		cvr: (vm) => get(vm, 'signupData.cvr', ''),
		company: (vm) => get(vm, 'signupData.company', ''),
		consultant: {
			get() {
				return this.selectedConsultant;
			},
			set(newValue) {
				this.selectedConsultant = newValue;
				this.signupData.consultant = newValue.name;
				this.signupData.consultantId = newValue.consultantId;
			},
		},
		industry: {
			get() {
				return this.selectedIndustry;
			},
			set(newValue) {
				this.selectedIndustry = newValue;
				this.signupData.industry = newValue.title;
				this.signupData.industryCode = newValue.industryCode;
			},
		},
		subscription: {
			get() {
				return this.selectedSubscription;
			},
			set(newValue) {
				this.selectedSubscription = newValue;
				this.signupData.subscription = newValue.title;
				this.signupData.subscriptionId = newValue.subscriptionId;
			},
		},
	},
	watch: {
		cvr() {
			this.showMessage = false;
			if (this.cvr === '') {
				this.$options.autoComplete.cancel();
			} else if (/^[0-9]{8}$/.test(this.cvr)) {
				const param = {
					cvr: this.cvr,
				};
				this.autoComplete(param);
			}
		},
	},
	methods: {
		spaceToNbsp(str) {
			return str.replace(' ', '&nbsp;');
		},
		setupPlaceholder(str) {
			return `${str}...`;
		},
		setupEmployeesStr(amountStr, amount) {
			return `${amountStr} ${i18n.tc('employee', amount)}`;
		},
		resetStatus() {
			this.submitStatus = '';
		},
		setupSignupData() {
			return {
				company: '',
				att_name: '',
				att_email: '',
				cvr: '',
				phone: '',
				email: '',
				website: '',
				invoice_email: '',
				address: '',
				postcode: '',
				city: '',
				industry: '',
				consultant: '',
				subscription: '',
				note: '',
				newsletter: [],
			};
		},
		prepareLists() {
			if (this.newsletterChecked) {
				this.popup = 'newsletter-signup-agreements';
				this.signupData.newsletter = [
					'business_esbjerg',
					'entrepreneur',
					'invest_in_esbjerg',
				];
			} else {
				this.acceptNewsletterTerms = false;
				this.signupData.newsletter = [];
			}
		},
		declineNewsletter() {
			this.popup = '';
			this.newsletterChecked = false;
			this.signupData.newsletter = [];
			this.acceptNewsletterTerms = false;
		},
		acceptSubmit() {
			this.popup = '';
		},
		validateBeforeSubmit() {
			this.$validator.validateAll().then(() => {
				if (this.errors.items.length === 0) {
					this.submit(this.signupData);
				} else {
					this.$scrollTo(this.$refs[this.errors.items[0].field]);
				}
			});
		},
		submit(data) {
			if (this.honey === '') {
				this.isSubmitting = true;
				this.$emit('member-signup-submitting', true);
				$.post('/wp-json/be/v1/member-signup', JSON.stringify(data))
					.then((result) => {
						if (typeof result != 'object') {
							result = JSON.parse(result);
						}
						this.submitStatus = result.status;
						this.$validator.reset();
						this.signupData = this.setupSignupData();
						this.newsletterChecked = false;
						this.$emit('member-signup-status', this.submitStatus);

						if (this.submitStatus === 'success') {
							trackMemberSignup();
						}
					})
					.catch(() => {
						this.submitStatus = 'error';
						this.$emit('member-signup-status', this.submitStatus);
					})
					.always((this.isSubmitting = false));
			}
		},
		autoComplete(param) {
			if (!this.hasTimeout) {
				this.$options.autoComplete(param);
			}
		},
	},
	created() {
		this.signupData = this.setupSignupData();
		this.$options.autoComplete = debounce(bind(autoComplete, this), 1000);
		this.newsletterPopup = JSON.parse(this.newsletterPopupFields);
	},
};

function autoComplete(param) {
	const endpoint = '/wp-json/be/v1/cvr-lookup/';
	this.showMessage = false;
	this.isFetching = true;
	getRequest(endpoint, param)
		.then((result) => {
			if (typeof result != 'object') {
				result = JSON.parse(result);
			}

			if (result.message === 'One hit') {
				this.hasTimeout = true;

				const cvr = get(result, 'data.cvr', null);
				if (get(this, 'signupData.cvr', null) !== null && cvr !== null) {
					if (cvr == false) {
						this.signupData.cvr = null;
					} else {
						this.signupData.cvr = cvr;
					}
				}

				const company = get(result, 'data.company', null);
				if (
					get(this, 'signupData.company', null) !== null &&
					company !== null
				) {
					if (company == false) {
						this.signupData.company = null;
					} else {
						this.signupData.company = company;
					}
				}

				const email = get(result, 'data.email', null);
				if (get(this, 'signupData.email', null) !== null && email !== null) {
					if (email == false) {
						this.signupData.email = null;
					} else {
						this.signupData.email = email;
					}
				}

				const phone = get(result, 'data.phone', null);
				if (get(this, 'signupData.phone', null) !== null && phone !== null) {
					if (phone == false) {
						this.signupData.phone = null;
					} else {
						this.signupData.phone = phone;
					}
				}

				const addr = get(result, 'data.address.addr', null);
				if (get(this, 'signupData.address', null) !== null && addr !== null) {
					if (addr == false) {
						this.signupData.address = null;
					} else {
						this.signupData.address = addr;
					}
				}

				const zip = get(result, 'data.address.zip', null);
				if (get(this, 'signupData.postcode', null) !== null && zip !== null) {
					if (zip == false) {
						this.signupData.postcode = null;
					} else {
						this.signupData.postcode = zip;
					}
				}

				const city = get(result, 'data.address.city', null);
				if (get(this, 'signupData.city', null) !== null && city !== null) {
					if (city == false) {
						this.signupData.city = city;
					} else {
						this.signupData.city = city;
					}
				}

				this.$nextTick(() => {
					this.hasTimeout = false;
				});

				this.responseMessage = 'Data hentet med success fra CVR.dk';
				this.messageClass = 'o-input__success';
			} else {
				this.responseMessage = 'CVR nr. blev ikke fundet hos CVR.dk';
				this.messageClass = 'o-input__error';
			}
		})
		.always(() => {
			this.isFetching = false;
			this.$nextTick(() => {
				this.showMessage = true;
			});
		});
}

/**
 * Make request to WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getRequest(endpoint, params) {
	return $.get(endpoint, params);
}
